import React from 'react';
import './ImageWithDescription.css';

const ImageWithDescription = ({ imageSrc, imageAlt, description }) => {
    return (
        <div className='container'>
            <div className="image-with-description">
                <img src={imageSrc} alt={imageAlt} className="image" />
                <div className="description">
                    {description.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ImageWithDescription;
